import { IList } from "../../interfaces/default";

export enum GlobalActions {
  COUNTRIES = "COUNTRIES",
  COUNTRIES_SUCCESS = "COUNTRIES_SUCCESS",
  COUNTRIES_FAILURE = "COUNTRIES_FAILURE",
  STATES = "STATES",
  STATES_SUCCESS = "STATES_SUCCESS",
  STATES_FAILURE = "STATES_FAILURE",
  IOS_VERSION = "IOS_VERSION",
  IOS_VERSION_SUCCESS = "IOS_VERSION_SUCCESS",
  IOS_VERSION_FAILURE = "IOS_VERSION_FAILURE",
  ANDROID_VERSION = "ANDROID_VERSION",
  ANDROID_VERSION_SUCCESS = "ANDROID_VERSION_SUCCESS",
  ANDROID_VERSION_FAILURE = "ANDROID_VERSION_FAILURE",
  AGE_GROUP = "AGE_GROUP",
  AGE_GROUP_SUCCESS = "AGE_GROUP_SUCCESS",
  AGE_GROUP_FAILURE = "AGE_GROUP_FAILURE",
  LANGUAGE = "LANGUAGE",
  LANGUAGE_SUCCESS = "LANGUAGE_SUCCESS",
  LANGUAGE_FAILURE = "LANGUAGE_FAILURE",
  INTEREST = "INTEREST",
  INTEREST_SUCCESS = "INTEREST_SUCCESS",
  INTEREST_FAILURE = "INTEREST_FAILURE",
}

interface IGetStatesAction {
  type: GlobalActions.STATES;
}

export const getStatesAction = (): IGetStatesAction => ({
  type: GlobalActions.STATES,
});

interface IGetStatesSuccessAction {
  type: GlobalActions.STATES_SUCCESS;
  payload: Array<IList>;
}

export const getStatesSuccessAction = (
  payload: Array<IList>,
): IGetStatesSuccessAction => ({
  type: GlobalActions.STATES_SUCCESS,
  payload,
});

interface IGetStatesFailureAction {
  type: GlobalActions.STATES_FAILURE;
  payload: { error: string };
}

export const getStatesFailureAction = (
  error: string,
): IGetStatesFailureAction => ({
  type: GlobalActions.STATES_FAILURE,
  payload: { error },
});

interface IGetCountriesAction {
  type: GlobalActions.COUNTRIES;
}

export const getCountriesAction = (): IGetCountriesAction => ({
  type: GlobalActions.COUNTRIES,
});

interface IGetCountriesSuccessAction {
  type: GlobalActions.COUNTRIES_SUCCESS;
  payload: Array<IList>;
}

export const getCountriesSuccessAction = (
  payload: Array<IList>,
): IGetCountriesSuccessAction => ({
  type: GlobalActions.COUNTRIES_SUCCESS,
  payload,
});

interface IGetCountriesFailureAction {
  type: GlobalActions.COUNTRIES_FAILURE;
  payload: { error: string };
}

export const getCountriesFailureAction = (
  error: string,
): IGetCountriesFailureAction => ({
  type: GlobalActions.COUNTRIES_FAILURE,
  payload: { error },
});

interface IGetIOSVersionAction {
  type: GlobalActions.IOS_VERSION;
}

export const getIOSVersionAction = (): IGetIOSVersionAction => ({
  type: GlobalActions.IOS_VERSION,
});

interface IGetIOSVersionSuccessAction {
  type: GlobalActions.IOS_VERSION_SUCCESS;
  payload: Array<IList>;
}

export const getIOSVersionSuccessAction = (
  payload: Array<IList>,
): IGetIOSVersionSuccessAction => ({
  type: GlobalActions.IOS_VERSION_SUCCESS,
  payload,
});

interface IGetIOSVersionFailureAction {
  type: GlobalActions.IOS_VERSION_FAILURE;
  payload: { error: string };
}

export const getIOSVersionFailureAction = (
  error: string,
): IGetIOSVersionFailureAction => ({
  type: GlobalActions.IOS_VERSION_FAILURE,
  payload: { error },
});

interface IGetAndroidVersionAction {
  type: GlobalActions.ANDROID_VERSION;
}

export const getAndroidVersionAction = (): IGetAndroidVersionAction => ({
  type: GlobalActions.ANDROID_VERSION,
});

interface IGetAndroidVersionSuccessAction {
  type: GlobalActions.ANDROID_VERSION_SUCCESS;
  payload: Array<IList>;
}

export const getAndroidVersionSuccessAction = (
  payload: Array<IList>,
): IGetAndroidVersionSuccessAction => ({
  type: GlobalActions.ANDROID_VERSION_SUCCESS,
  payload,
});

interface IGetAndroidVersionFailureAction {
  type: GlobalActions.ANDROID_VERSION_FAILURE;
  payload: { error: string };
}

export const getAndroidVersionFailureAction = (
  error: string,
): IGetAndroidVersionFailureAction => ({
  type: GlobalActions.ANDROID_VERSION_FAILURE,
  payload: { error },
});

interface IGetAgeGroupAction {
  type: GlobalActions.AGE_GROUP;
}

export const getAgeGroupAction = (): IGetAgeGroupAction => ({
  type: GlobalActions.AGE_GROUP,
});

interface IGetAgeGroupSuccessAction {
  type: GlobalActions.AGE_GROUP_SUCCESS;
  payload: Array<IList>;
}

export const getAgeGroupSuccessAction = (
  payload: Array<IList>,
): IGetAgeGroupSuccessAction => ({
  type: GlobalActions.AGE_GROUP_SUCCESS,
  payload,
});

interface IGetAgeGroupFailureAction {
  type: GlobalActions.AGE_GROUP_FAILURE;
  payload: { error: string };
}

export const getAgeGroupFailureAction = (
  error: string,
): IGetAgeGroupFailureAction => ({
  type: GlobalActions.AGE_GROUP_FAILURE,
  payload: { error },
});

interface IGetLanguageAction {
  type: GlobalActions.LANGUAGE;
}

export const getLanguageAction = (): IGetLanguageAction => ({
  type: GlobalActions.LANGUAGE,
});

interface IGetLanguageSuccessAction {
  type: GlobalActions.LANGUAGE_SUCCESS;
  payload: Array<IList>;
}

export const getLanguageSuccessAction = (
  payload: Array<IList>,
): IGetLanguageSuccessAction => ({
  type: GlobalActions.LANGUAGE_SUCCESS,
  payload,
});

interface IGetLanguageFailureAction {
  type: GlobalActions.LANGUAGE_FAILURE;
  payload: { error: string };
}

export const getLanguageFailureAction = (
  error: string,
): IGetLanguageFailureAction => ({
  type: GlobalActions.LANGUAGE_FAILURE,
  payload: { error },
});

interface IGetInterestAction {
  type: GlobalActions.INTEREST;
}

export const getInterestAction = (): IGetInterestAction => ({
  type: GlobalActions.INTEREST,
});

interface IGetInterestSuccessAction {
  type: GlobalActions.INTEREST_SUCCESS;
  payload: Array<IList>;
}

export const getInterestSuccessAction = (
  payload: Array<IList>,
): IGetInterestSuccessAction => ({
  type: GlobalActions.INTEREST_SUCCESS,
  payload,
});

interface IGetInterestFailureAction {
  type: GlobalActions.INTEREST_FAILURE;
  payload: { error: string };
}

export const getInterestFailureAction = (
  error: string,
): IGetInterestFailureAction => ({
  type: GlobalActions.INTEREST_FAILURE,
  payload: { error },
});

export type IGlobalActions =
  | IGetIOSVersionAction
  | IGetIOSVersionSuccessAction
  | IGetIOSVersionFailureAction
  | IGetAndroidVersionAction
  | IGetAndroidVersionSuccessAction
  | IGetAndroidVersionFailureAction
  | IGetAgeGroupAction
  | IGetAgeGroupSuccessAction
  | IGetAgeGroupFailureAction
  | IGetLanguageAction
  | IGetLanguageSuccessAction
  | IGetLanguageFailureAction
  | IGetInterestAction
  | IGetInterestSuccessAction
  | IGetInterestFailureAction
  | IGetCountriesAction
  | IGetCountriesSuccessAction
  | IGetCountriesFailureAction
  | IGetStatesAction
  | IGetStatesSuccessAction
  | IGetStatesFailureAction;
